<div id="explorerSideOffcanvas" 
     class="offcanvas offcanvas-start" 
     [ngClass]="{'show': tabService.navInfo.explorer.sideViewVisible}" 
     data-bs-scroll="true" 
     data-bs-backdrop="false" 
     tabindex="-1" 
     aria-labelledby="offcanvasScrollingLabel">
    <div class="offcanvas-header">
        @if (tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 0) {
            <h5 class="offcanvas-title">SEARCH</h5>
        }
        @if (tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 1) {
            <h5 class="offcanvas-title">PROCESSORS</h5>
        }
        @if (tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 2) {
            <h5 class="offcanvas-title">JOB CONFIGURATION</h5>
        }
        <button type="button" (click)="tabService.hideExplorerSidebarArea()" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        <!-- SEARCH VIEW -->
        @if (tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 0) {
            <div id="explorerSearchBody">
                <div id="collectionList" *ngIf="!searchService.selectedCollection">
                    <input [(ngModel)]="searchService.collectionFilterText" placeholder="Filter..." />
                    @for (collection of searchService.filteredCollectionList(); track collection.id) {
                        <div class="explorerProcessorListItem"
                            (click)="searchService.selectCollection(collection)" title="{{collection.description}}">
                            <h3>{{ collection.title }}</h3>
                        <!--   <p>{{ collection.description }}</p> -->
                        </div>
                    }
                </div>
                <div id="collectionSearch" *ngIf="searchService.selectedCollection">
                    <button id="resetCollectionButton" type="button" (click)="searchService.selectCollection(undefined)" class="btn-close" 
                        aria-label="Reset collection" title="Reset collection"></button>
                    <h3>{{ searchService.selectedCollection.title }}</h3>
                    <p>{{ searchService.selectedCollection.description }}</p>
                    <!-- Search constraints here -->
                    <h4>Bounding box</h4>
                    <div class="searchBoundingBox">{{ mapService.mapstore.aoi.selectedArea }}</div>
                    <h4>Start date</h4>
                    <input class="searchInput" type="date" id="startDate" name="startDate">
                    <h4>End date</h4>
                    <input class="searchInput" type="date" id="endDate" name="endDate">
                    <!-- Collection specific fields here -->
                    <div *ngFor="let x of searchService.selectedCollection.uiSearchFields" >
                        <h4>{{x.label}}</h4>
                        <input *ngIf="!x.options" class="searchInput" id="{{x.queryable}}" name="{{x.queryable}}">
                        <select *ngIf="x.options" class="searchInput" id="{{x.queryable}}" name="{{x.queryable}}">
                            <option *ngFor="let o of x.options" value="{{o}}">{{o}}</option>
                        </select>
                    </div>
                    <!--
                    <h4>Maximum cloud coverage</h4>
                    <input class="searchInput" id="searchInputCloudCoverage" name="searchInputCloudCoverage">
                    <h4>Title</h4>
                    <input class="searchInput" id="searchInputTitle" name="searchInputTitle">
                    -->
                    <!-- Search button here -->
                    <button class="processLaunchButton" (click)="searchCollection()">
                        <i class="material-icons" title="Search" aria-label="Search">search</i></button>
                </div>
            </div>
        }
        <!-- SERVICES VIEW -->
        @if (tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 1) {
            <div id="explorerProcessorsBody">
                <div *ngIf="!userService.userInfo">
                    <h3>Please log in</h3>
                </div>
                <div *ngIf="userService.userInfo">
                    <div *ngIf="!deployProcessView">
                        @for (process of userService.processes(); track process.id) {
                            <div class="explorerProcessorListItem"
                                (click)="selectProcess(process)">
                                <h3>{{ process.title }} ({{ process.version }})</h3>
                                <p>{{ process.description }}</p>
                            </div>
                        }
                        <button class="processLaunchButton" (click)="showDeployProcessView()">
                            <i class="material-icons" title="Deploy process" aria-label="Deploy process">add</i></button>
                    </div>
                    <div class="deployProcess" *ngIf="deployProcessView">
                        <button id="hideDeployProcessViewButton" type="button" (click)="hideDeployProcessView()" class="btn-close" 
                            aria-label="Cancel" title="Cancel"></button>
                        <h3>Deploy process</h3>
                        <h4>The CWL describing the process:</h4>
                        <div id="cwldiv">
                        <textarea class="cwlContent" id="cwlContent" name="cwlContent" rows="20"></textarea>
                        </div>
                        <div id="builtInProcessDiv" *ngIf="userService.availableBuiltInProcesses.length > 0">
                            <h4>Select a built-in process to deploy</h4>
                            <select name="builtInProcess" class="builtInProcess" id="builtInProcess">
                                <option value="">Select a process</option>
                                <option *ngFor="let proc of userService.availableBuiltInProcesses" value="{{ proc.id }}">{{ proc.title }} {{proc.version}}</option>
                            </select>
                        </div>
                        <!-- Add button here -->
                        <button class="processLaunchButton" (click)="deployProcess()">
                            <i class="material-icons" title="Deploy process" aria-label="Deploy process">add</i></button>
                    </div>
                </div>
            </div>
        }
        <!-- JOB CONFIGURATION VIEW -->
        @if (tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 2) {
            <div id="explorerWorkspaceBody">
                <div *ngIf="!tabService.selectedProcess">
                    <h3>No selected service</h3>
                    <p>Please select a service from the service panel first.</p>
                </div>
                <div *ngIf="tabService.selectedProcess">
                    <section class="workspace-header">
                        <div class="row service-header">
                            <h3>{{ tabService.selectedProcess.title }} ({{ tabService.selectedProcess.version }})</h3>
                        </div>
                        <div class="row service-description">
                            <p>{{ tabService.selectedProcess.description }}</p>
                        </div>
                    </section>
                    <section class="workspace-content item-list">
                        <div *ngIf="tabService.selectedProcessInputs">
                            <form id="processInputForm">
                                <div *ngFor="let input of tabService.selectedProcessInputs()">
                                    <div class="processInputTitle">{{ input.title }}</div>
                                    <div class="processInputDescription">{{ input.description }}</div>
                                    <input *ngFor="let fieldid of input.fieldids"
                                        class="processInputInput" id="{{ fieldid }}" name="{{ fieldid }}">
                                    <div class="addInputField" *ngIf="input.maxOccurs && input.maxOccurs > 1"
                                        (click)="addAnotherFieldForInput(input)">
                                        <i class="material-icons addInputFieldIcon" title="Add another input" aria-label="Add another input">add</i></div>
                                </div>
                            </form>
                            <div id="blankWorkspaceEnd"></div>
                            <button id="undeployProcessButton" class="sidebarButtonFloatingLeft" (click)="undeployProcess()">
                                <i class="material-icons" title="Undeploy process" aria-label="Undeploy process">delete</i></button>
                            <button class="processLaunchButton" (click)="launchProcess()">
                                <i class="material-icons" title="Launch" aria-label="Launch">play_arrow</i></button>
                        </div>
                    </section>
                </div>
            </div>
        }
    </div>
</div>
